/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCoinPound = createReactComponent("outline", "coin-pound", "IconCoinPound", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M15 9a2 2 0 1 0 -4 0v5a2 2 0 0 1 -2 2h6", "key": "svg-1" }], ["path", { "d": "M9 12h4", "key": "svg-2" }]]);

export { IconCoinPound as default };
//# sourceMappingURL=IconCoinPound.mjs.map
